
define('text!modules/strategy/supply/shared/templates/bin_group_header.html',[],function () { return '<div class="group-c">\n    <span>{{bin_group_name}}</span>\n    <span class="group-count">{{count}}</span>\n</div>\n';});

